export const URLS = {
  AUTH_TEAM_DAY_OFF_MANAGEMENT: 'governance/projectTeam/teamDayOffManagement',
  AUTH_MY_TIME_OFF: 'governance/projectTeam/myTimeOff',
  AUTH_TEAM_ASSIGNMENT: 'governance/projectTeam/teamAssignment',
  AUTH_EFFORT_MATRIX: 'governance/projectTeam/effortMatrix',
  AUTH_PROJECT_MILESTONES: 'governance/projectTeam/projectMilestones',
  AUTH_TEAM_CAPACITY: 'governance/projectTeam/teamCapacity',
  AUTH_INDIVIDUAL_CAPACITY: 'governance/projectTeam/individualCapacity/:id'
}
